import { render } from "./OverviewMailAccount.vue?vue&type=template&id=86d4e7de&scoped=true"
import script from "./OverviewMailAccount.vue?vue&type=script&lang=js"
export * from "./OverviewMailAccount.vue?vue&type=script&lang=js"

import "./OverviewMailAccount.vue?vue&type=style&index=0&id=86d4e7de&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86d4e7de"]])

export default __exports__